const DEFAULT_THUMBNAIL_WIDTH = 400; // Ancho del recorte del thumbnail por defecto
const LIMIT_THUMBNAIL_SIZE = 102400;

export const imageToJpg = (file: File): Promise<Blob | null> =>
  new Promise((resolve) => {
    const img = new Image();

    img.onload = convert;
    img.src = URL.createObjectURL(file);

    function convert() {
      URL.revokeObjectURL(img.src);

      const c = document.createElement("canvas");
      const ctx = c.getContext("2d");

      c.width = img.width;
      c.height = img.height;

      if (ctx) ctx.drawImage(img, 0, 0);

      c.toBlob(resolve, "image/jpeg", 1);
    }
  });

export interface ThumbnailObject {
  thumbnail: string;
  width: number;
  height: number;
}

export const readAndCreateThumbnail = (file: File | Blob): Promise<ThumbnailObject> => {
  const reader = new FileReader();

  if (file) {
    reader.readAsDataURL(file);
  }

  return new Promise((resolve, reject) => {
    reader.onloadend = async function () {
      const image = reader.result;

      if (image) {
        const { thumbnail, width, height } = await createThumbnail(DEFAULT_THUMBNAIL_WIDTH, image);

        if (typeof thumbnail === "string") {
          let thumbWidth = DEFAULT_THUMBNAIL_WIDTH;
          let currentThubnail = thumbnail;
          let currentHeight = height;
          let currentWidth = width;

          while (currentThubnail.length > LIMIT_THUMBNAIL_SIZE) {
            const differenceSize = currentThubnail.length - LIMIT_THUMBNAIL_SIZE;
            thumbWidth -= Math.floor((thumbWidth * differenceSize) / currentThubnail.length);

            const newThumb = await createThumbnail(thumbWidth, image);

            currentThubnail = newThumb.thumbnail;
            currentHeight = newThumb.height;
            currentWidth = newThumb.width;
          }

          resolve({ thumbnail: currentThubnail, height: currentHeight, width: currentWidth });
        } else {
          reject("Invalid format thumbnail");
        }
      }
    };
  });
};

const createThumbnail = (
  size: number = DEFAULT_THUMBNAIL_WIDTH,
  image: string | ArrayBuffer
): Promise<ThumbnailObject> =>
  new Promise((resolve) => {
    const img = new Image();

    img.src = typeof image === "string" ? image : "";

    img.onload = function () {
      if (img.width > size) {
        const oc = document.createElement("canvas");
        const octx = oc.getContext("2d");

        oc.width = img.width;
        oc.height = img.height;
        octx?.drawImage(img, 0, 0);

        if (img.width > img.height) {
          oc.height = (img.height / img.width) * size;
          oc.width = size;
        } else {
          oc.width = (img.width / img.height) * size;
          oc.height = size;
        }

        octx?.drawImage(oc, 0, 0, oc.width, oc.height);
        octx?.drawImage(img, 0, 0, oc.width, oc.height);

        const imgUrl = oc.toDataURL("image/jpeg");

        resolve({
          thumbnail: imgUrl.replace("image/jpeg", "image/jpg"),
          width: img.width,
          height: img.height,
        });
      } else {
        resolve({
          thumbnail: (image as string).replace("image/jpeg", "image/jpg"),
          width: img.width,
          height: img.height,
        });
      }
    };
  });
